import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag"
import { windowUpdate, removeReCaptchaBadge } from './shared/common'
import { initHeaderIconSwap } from './shared/headerIconSwap'
import { initHeaderTransparentBg } from './shared/headerTransparentBg'
import { initHeaderCalendarReveal } from './shared/headerCalendarReveal'
// controllers
import Controller from './controllers/Controller'
import MapController from './controllers/MapController'
import AlertsController from './controllers/AlertsController'
// views
// import View from './views/View'

const routes = {
  'webflow': {
    controller: Controller,
    view: RytmWebflow.WebflowView
  },
  'list': {
    controller: Controller,
    view: RytmWebflow.WebflowListView
  },
  'map': {
    controller: MapController,
    view: RytmWebflow.WebflowView
  },
  'alerts': {
    controller: AlertsController,
    view: RytmWebflow.WebflowView
  },
}
const aswapProps = {
  animationTimeHide: 800,
  animationTimeShow: 800,
  preloadOnHover: false,
  cacheOn: true,
  refreshOnSameUrl: false,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    WCAG.dialogCloseAll()
    windowUpdate()
    RytmWebflow.showUp.rebuild()
    initHeaderIconSwap()
    initHeaderTransparentBg()
    initHeaderCalendarReveal()
  },
  onViewHide: () => {
    WCAG.dialogCloseAll()
    removeReCaptchaBadge()
    // RytmWebflow.bootsrap5.hideFlyovers()
  },
  onViewHidden: () => {
    // destroy...
  },
  onRequestSameUrl: () => {
    // same url request
    // RytmWebflow.bootsrap5.hideFlyovers();
  },
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
}